export default __webpack_public_path__ + "static/media/like-icon.04064c4b.webp";